<template>
	<div class="doc-pro-maintenance">
		<a-card
			title="项目执行及维护"
			:bordered="false"
			class="erp-pro-basicinfo-card doc-pro-maintenance-edit"
			v-if="basicInfoProps.curr_step_num<stepInfo.stepNum"
			:loading="loading"
		>
			<div class="doc-pro-maintenance-edit-title" v-if="!loading">项目执行</div>
			<create-doc-form
				ref="createPerformForm"
				v-if="field_options.proj_execute.length>0 && createFormShow && !loading"
				:init-data="initNewData"
				:form-types="field_options.proj_execute"
				@change="changeNewField"
			></create-doc-form>
			<div class="doc-pro-maintenance-edit-title" v-if="!loading">项目维护</div>
			<create-doc-form
				ref="createMainForm"
				v-if="field_options.proj_maintain.length>0&& createFormShow && !loading"
				:init-data="initNewData"
				:form-types="field_options.proj_maintain"
				@change="changeNewField"
			></create-doc-form>
		</a-card>
		<div
			class="doc-basic-info"
			style="margin-top:16px;"
			v-if="basicInfoProps.curr_step_num>=stepInfo.stepNum"
		>
			<doc-basic-info-card
				:loading="loadingInfo"
				:can-edit="canEdit"
				:card-title="'项目执行及维护'"
				:edit-label="'编辑'"
				:info="basicCardLayout"
				@edit="onEdit"
			></doc-basic-info-card>
			<doc-table-card :can-edit="canEdit" :layout="performTableCard"></doc-table-card>
		</div>
		<a-modal
			title="编辑项目执行及维护"
			v-model="showEditModal"
			v-if="basicInfoProps.curr_step_num>=stepInfo.stepNum && showEditModal"
			width="640px"
		>
			<create-doc-form
				ref="editForm"
				v-if="field_options_form.length>0"
				:init-data="initData"
				:form-types="field_options_form"
				@change="editDocChange"
			></create-doc-form>
			<template slot="footer">
				<a-button @click="handleCancel">取消</a-button>
				<a-button type="primary" :loading="submitLoading" @click="handleCreateOk">提交</a-button>
			</template>
		</a-modal>
		<footer-btn
			v-if="basicInfoProps.curr_step_num<stepInfo.stepNum && canEdit"
			:btnText="btnText"
			@on-save="onSave"
			:noCancelBtn="true"
			@on-cancel="onCancel"
		></footer-btn>
	</div>
</template>

<script>
import _ from "lodash";
import FooterBtn from "../../components/FooterBtn.vue";
import SvgIcDate from "../../assets/svg/ic-date-o.svg";
import moment from "moment";
import {
  initDocOptions,
  getContract,
  addDoc,
  modifyContract,
  getPerformanceList
} from "../../services/DocService.js";
import { provinces } from "../../utils/tools.js";

export default {
  props: {
    basicInfoProps: Object,
    canEdit: Boolean,
    stepInfo: Object
  },
  components: {
    SvgIcDate
  },
  data() {
    return {
      showEditModal: false,
      createFormShow: true,
      initOptions: true,
      loading: false,
      loadingInfo: false,
      btnText: {
        cancelText: "重置",
        okText: "保存"
      },
      field_options: {
        proj_execute: [],
        proj_maintain: []
      },
      field_options_form: [],
      performTableCard: {
        cardTitle: "履约情况",
        hasStatistical: false,
        tableColumns: [
          {
            title: "填写时间",
            dataIndex: "operate_time",
            key: "operate_time"
          },
          {
            title: "项目状态",
            dataIndex: "project_situation",
            key: "project_situation"
          },
          {
            title: "近况更新期限",
            dataIndex: "recent_term",
            key: "recent_term"
          },
          {
            title: "是否考核",
            dataIndex: "need_assessment",
            key: "need_assessment"
          },
          {
            title: "延迟分类",
            dataIndex: "delay_category",
            key: "delay_category"
          },
          {
            title: "延迟原因",
            dataIndex: "delay_reason",
            key: "delay_reason"
          },
          {
            title: "延迟责任方",
            dataIndex: "delay_responsible_party",
            key: "delay_responsible_party"
          },
          {
            title: "是否有书面确认",
            dataIndex: "has_written_confirmation",
            key: "has_written_confirmation"
          },
          {
            title: "备注",
            dataIndex: "progress_remark",
            key: "progress_remark"
          }
        ],
        tableData: [],
        loading: false
      },
      form: this.$form.createForm(this),

      initData: {},
      initNewData: {},

      field_label: [],
      proj_execute: {
        recent_term: "2323",
        contract_date: "2019-05-05"
      },
      proj_maintain: {
        contract_customer_sn: "2323",
        single_stamp_date: "2019-05-09"
      },
      docBasicInfo: {},
      // basicCardData: [],
      submitLoading: false,
    };
  },

  computed: {
    basicCardData1() {
      if (this.docBasicInfo.field_label) {
        const field_label = this.docBasicInfo.field_label;
        const contract_info = this.docBasicInfo.contract_info;
        const infos = [];
        if (field_label.proj_execute) {
          field_label.proj_execute.forEach((item, index) => {
            if (
              _.isObject(contract_info[item.field]) &&
              contract_info[item.field]
            ) {
              infos.push({
                label: item.label,
                key: item.field,
                value: contract_info[item.field].name
              });
            } else if (!_.isObject(contract_info[item.field])) {
              infos.push({
                label: item.label,
                key: item.field,
                value: contract_info[item.field]
              });
            }
          });
          const infoGroups = [];
          for (let i = 1; i <= Math.ceil(infos.length / infos.length); i += 1) {
            const item = infos.slice(
              (i - 1) * infos.length,
              (i - 1) * infos.length + infos.length
            );
            infoGroups.push(item);
          }
          return infoGroups;
        }
      }
    },
    basicCardData2() {
      if (this.docBasicInfo.field_label) {
        const field_label = this.docBasicInfo.field_label;
        const contract_info = this.docBasicInfo.contract_info;
        const infos2 = [];
        if (field_label.proj_maintain) {
          field_label.proj_maintain.forEach((item, index) => {
            if (
              _.isObject(contract_info[item.field]) &&
              contract_info[item.field]
            ) {
              infos2.push({
                label: item.label,
                key: item.field,
                value: contract_info[item.field].name
              });
            } else if (!_.isObject(contract_info[item.field])) {
              infos2.push({
                label: item.label,
                key: item.field,
                value: contract_info[item.field]
              });
            }
          });
          const infoGroups2 = [];
          for (
            let i = 1;
            i <= Math.ceil(infos2.length / infos2.length);
            i += 1
          ) {
            const item = infos2.slice(
              (i - 1) * infos2.length,
              (i - 1) * infos2.length + infos2.length
            );
            infoGroups2.push(item);
          }
          return infoGroups2;
        }
      }
    },
    basicCardLayout() {
      return [
        {
          hasTitle: true,
          title: "项目执行",
          data: this.basicCardData1
        },
        {
          hasTitle: true,
          title: "项目维护",
          data: this.basicCardData2
        }
      ];
    }
  },

  methods: {
    fetchContractInfo() {
      if (this.basicInfoProps.curr_step_num < this.stepInfo.stepNum) {
        return;
      }
      this.loadingInfo = true;
      getContract({
        contract_id: this.basicInfoProps.contract_id,
        step_num: this.stepInfo.stepKey
      }).then(res => {
        ``;
        if (res.status === "success") {
          this.docBasicInfo = res.data;
          this.initData = _.cloneDeep(res.data.contract_info);
          for (let key in this.initData) {
            if (_.isObject(this.initData[key])) {
              this.initData[key] = this.initData[key].id;
            }
          }
          this.initDataBackup = _.cloneDeep(this.initData);
        } else {
          this.$Message.error(res.message);
        }
        this.loadingInfo = false;
      });
    },
    fetchDocEditOptions() {
      initDocOptions({
        contract_type: this.basicInfoProps.contract_type,
        archival_status: this.basicInfoProps.archival_status,
        step_num: this.stepInfo.stepKey,
        new: 0
      }).then(res => {
        if (res.status === "success") {
          let hospitalAreaObj = res.data.field_options.proj_execute.find(
            item => {
              return item.field === "hospital_area";
            }
          );
          hospitalAreaObj.tpl = "select";
          hospitalAreaObj.options = provinces;
          let array1 = _.cloneDeep(res.data.field_options.proj_execute);
          array1.unshift({
            name: "项目执行",
            tpl: "title"
          });
          let array2 = _.cloneDeep(res.data.field_options.proj_maintain);
          array2.unshift({
            name: "项目维护",
            tpl: "title"
          });
          this.field_options_form = array1.concat(array2);
          this.field_options_form_backup = _.cloneDeep(this.field_options_form);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    fetchDocOptions() {
      this.loading = true;
      initDocOptions({
        contract_type: this.basicInfoProps.contract_type,
        archival_status: this.basicInfoProps.archival_status,
        step_num: this.stepInfo.stepKey,
        new: 1
      }).then(res => {
        if (res.status === "success") {
          let hospitalAreaObj = res.data.field_options.proj_execute.find(
            item => {
              return item.field === "hospital_area";
            }
          );
          hospitalAreaObj.tpl = "select";
          hospitalAreaObj.options = provinces;
          this.field_options = res.data.field_options;
          this.field_options_backup = _.cloneDeep(res.data.field_options);
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false;
      });
    },
    changeNewField(val) {
      let keys = Object.keys(val);
      if (!keys.length) {
        return;
      }
      let name = keys[0];
      if (moment.isMoment(val[name].value)) {
        let fieldOpts = this.field_options.proj_execute.concat(
          this.field_options.proj_maintain
        );
        const obj = fieldOpts.find(item => {
          return item.field === name;
        });
        if (obj.tpl === "month") {
          val[name].value = moment(val[name].value).format("YYYY-MM");
        } else {
          val[name].value = moment(val[name].value).format("YYYY-MM-DD");
        }
      }
      this.initNewData[name] = val[name].value;
      let currFiledObj = this.field_options.proj_execute.find(item => {
        return item.field === name;
      });
      if (!currFiledObj) {
        currFiledObj = this.field_options.proj_maintain.find(item => {
          return item.field === name;
        });
        if (currFiledObj.target && currFiledObj.target !== "") {
          this.getTarget(
            currFiledObj.target,
            val[name].value,
            this.field_options.proj_maintain,
            this.field_options_backup.proj_maintain
          );
        }
      } else {
        if (currFiledObj.target && currFiledObj.target !== "") {
          this.getTarget(
            currFiledObj.target,
            val[name].value,
            this.field_options.proj_execute,
            this.field_options_backup.proj_execute
          );
        }
      }
    },
    onEdit(e) {
      this.initData = _.cloneDeep(this.initDataBackup);
      this.showEditModal = true;
    },
    editDocChange(val) {
      let keys = Object.keys(val);
      if (!keys.length) {
        return;
      }
      let name = keys[0];
      const currFiledObj = this.field_options_form.find(item => {
        return item.field === name;
      });
      if (moment.isMoment(val[name].value)) {
        if (currFiledObj.tpl === "month") {
          val[name].value = moment(val[name].value).format("YYYY-MM");
        } else {
          val[name].value = moment(val[name].value).format("YYYY-MM-DD");
        }
      }
      this.initData[name] = val[name].value;
      if (currFiledObj.target && currFiledObj.target !== "") {
        this.getTarget(
          currFiledObj.target,
          val[name].value,
          this.field_options_form,
          this.field_options_form_backup
        );
      }
    },
    getTarget(targetField, parentVal, fieldOpts, fieldOptsBackup) {
      fieldOpts = _.cloneDeep(fieldOptsBackup);
      fieldOpts.forEach(item => {
        if (item.field === targetField) {
          item.options = item.options.filter(
            option => Number(option.parent_id) === parentVal
          );
        }
      });
    },
    submit() {
      this.$refs.createPerformForm.form.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        this.$refs.createMainForm.form.validateFields((err1, fieldsValue) => {
          if (err1) {
            return;
          }
          this.initNewData.contract_sn = this.basicInfoProps.contract_sn;
          addDoc({
            contract_type: this.basicInfoProps.contract_type,
            archival_status: this.basicInfoProps.archival_status,
            contrat_data: this.initNewData,
            step_num: this.stepInfo.stepKey
          }).then(res => {
            if (res.status === "success") {
              this.$emit("change-step", {
                curr_step_num: this.stepInfo.stepNum,
                next_step: this.stepInfo.nextStepNum
              });
              this.fetchContractInfo();
            } else {
              this.$Message.error(res.message);
            }
          });
        });
      });
    },
    onSave() {
      this.submit();
    },
    onCancel() {
      this.initNewData = {};
      this.createFormShow = false;
      this.$nextTick(() => {
        this.createFormShow = true;
      });
    },
    handleCancel() {
      this.showEditModal = false;
    },
    handleCreateOk() {
      this.$refs.editForm.form.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        this.initData.contract_sn = this.basicInfoProps.contract_sn;
        if (
          this.initData.customer_name &&
          this.initData.customer_name.indexOf("_") > -1
        ) {
          this.initData.customer_name = this.initData.customer_name.split(
            "_"
          )[0];
        }
        this.submitLoading = true;
        modifyContract({
          contrat_data: this.initData,
          step_num: this.stepInfo.stepKey
        }).then(res => {
          if (res.status === "success") {
            this.fetchContractInfo();
            this.$emit("update-doc");
            this.showEditModal = false;
            this.submitLoading = false;
          } else {
            this.$Message.error(res.message);
            this.submitLoading = false;
          }
        });
      });
    },
    fetchPerformanceList() {
      this.performTableCard.loading = true;
      getPerformanceList({ contract_sn: this.basicInfoProps.contract_sn }).then(
        res => {
          if (res.status === "success") {
            res.data.pref_list.forEach((item, index) => {
              item.key = index;
            });
            this.performTableCard.tableData = res.data.pref_list;
          } else if (res.statua === "failed") {
            this.$Message.error(res.message);
          }
          this.performTableCard.loading = false;
        }
      );
    }
  },
  created() {},
  mounted() {
    this.fetchDocEditOptions();
    this.fetchDocOptions();
    this.fetchContractInfo();
    // this.fetchPerformanceList();
  }
};
</script>
<style lang="less">
.doc-pro-maintenance {
  .ant-card {
    margin-bottom: 16px;
  }
  &-edit {
    &-title {
      width: 100%;
      padding-bottom: 8px;
      margin-bottom: 24px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
      border-bottom: #dedede solid 1px;
    }
    .ant-form {
      width: 100%;
      &-item {
        width: 500px;
        &-label {
          min-width: 130px;
          text-align: right;
          color: rgba(0, 0, 0, 0.65);
        }
        &-control {
          width: 100%;
          .ant-calendar-picker {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
